import { Injectable } from "@angular/core";
import { CategoryModel } from "@core/models/categories";
import { BrandResult, GetProductBySkuQuery, ProductClient, ProductReturnModel, SkuResult, UsersClient } from "@core/services/api.service";
import { Action, createSelector, Selector, State, StateContext } from "@ngxs/store";
import { catchError, tap } from "rxjs/operators";
import { AddProductToCart, AssignCoverImageAction, AssignCoverImageFailAction, AssignCoverImageSuccessAction, GetProductBySkuAction, GetProductBySkuFailAction, GetProductBySkuSuccessAction, LoadProductsAction, LoadProductsActionFailAction, LoadProductsActionSuccessAction, SelectCategoryAction, UpdateBrandAction, UpdateCategoriesAction, UpdateDescriptionAction, UpdateDescriptionFailAction, UpdateDescriptionSuccessAction, UpdateTotalPrice, UploadProductImagesAction, UploadProductImagesFailAction, UploadProductImagesSuccessAction } from "./product.actions";
import { OpenToastrAction } from "@ngxs-store/ui-store/ui.actions";
import { ToastrType } from "@core/models/ui/toastr-config";
import { Navigate } from "@ngxs/router-plugin";


export class ProductStateModel {
  public isLoading: boolean;
  public ProductReturnModel: ProductReturnModel;
  public ProductBySkuCode: SkuResult;
  public ProductsByCategory: ProductReturnModel[];
  public brands: BrandResult[];
  public updateBrands: boolean;
  public categoriesList: string[];
  public categories: CategoryModel[];
  public updateCategories: boolean;
  totalPrice: any;

}
@State<ProductStateModel>({
  name: 'product',
  defaults: {
    isLoading: false,
    ProductReturnModel: new ProductReturnModel(),
    ProductBySkuCode: new SkuResult,
    ProductsByCategory: [],
    brands: [],
    categories: [],
    categoriesList: [],
    updateBrands: true,
    updateCategories: true,
    totalPrice: 0
  }
})
@Injectable()
export class ProductState {
  constructor(
    private productService: ProductClient
  ) { }

  @Selector()


  // Custom selector
  static getProduct(productCode: string) {
    return createSelector([ProductState], (productState: ProductStateModel) => {
      return productState['product'].ProductReturnModel.skuResults.find((x) => x.skuCode === productCode);
    });
  }
  @Selector()
  static isLoading(state: ProductStateModel) {
    return state.isLoading;
  }

  @Selector()
  static getBrands(state: ProductStateModel) {
    return state.brands;
  }

  @Selector()
  static getProductsResult(state: ProductStateModel) {
    return state.ProductReturnModel;
  }

  @Selector()
  static getProductBySkuCode(state: ProductStateModel) {
    return state.ProductBySkuCode;
  }


  @Selector()
  static getProductsCategoriesResult(state: ProductStateModel) {
    return state.categories;
  }

  // @Selector()
  // static getCartProducts (state: ProductStateModel) {
  //   return state.productCart;
  // }

  static getProdCat(ProdCat: string) {
    return createSelector([ProductState], (lookupState: ProductStateModel) => {
      return lookupState.ProductsByCategory.find((f) => f.skuResults.filter((p) => p.skuCategory === ProdCat));
    });
  }

  @Action(LoadProductsAction)
  loadProductsAction({ dispatch, patchState }: StateContext<ProductStateModel>, action: LoadProductsAction) {
    patchState({ isLoading: true });

    if (action.payload.updateFilters) {
      dispatch([new UpdateBrandAction(), new UpdateCategoriesAction()])
    }

    return this.productService.productSearch(action.payload.loadProductsQuery).pipe(
      tap((result) => dispatch(new LoadProductsActionSuccessAction({ ProductReturnModel: result }))),
      catchError((err) => dispatch(new LoadProductsActionFailAction(err)))
    );
  }

  @Action(LoadProductsActionSuccessAction)
  loadProductsActionSuccessAction(ctx: StateContext<ProductStateModel>, action: LoadProductsActionSuccessAction) {
    ctx.patchState({
      isLoading: false,
      ProductReturnModel: action.payload.ProductReturnModel,
    });

    if (ctx.getState().updateCategories) {
      action.payload.ProductReturnModel.categoryResults.forEach(element => {
        ctx.patchState({
          categories: [...ctx.getState().categories, ...[new CategoryModel(element)]]
        });
      });
      ctx.patchState({
        updateCategories: false
      });
    }

    if (ctx.getState().updateBrands) {
      ctx.patchState({
        brands: action.payload.ProductReturnModel.brandResults,
        updateBrands: false,
      });
    }
  }

  @Action(LoadProductsActionFailAction)
  loadProductsActionFailAction(ctx: StateContext<ProductStateModel>, action: LoadProductsActionFailAction) {
    ctx.patchState({
      isLoading: false,
      ProductReturnModel: null
    });
  }

  @Action(UpdateCategoriesAction)
  updateCategoriesAction(ctx: StateContext<ProductStateModel>, action: UpdateCategoriesAction) {
    ctx.patchState({
      updateCategories: true,
      categories: []
    });
  }

  @Action(UpdateBrandAction)
  updateBrandAction(ctx: StateContext<ProductStateModel>, action: UpdateBrandAction) {
    ctx.patchState({
      updateBrands: true
    });
  }

  @Action(SelectCategoryAction)
  selectCategoryAction(ctx: StateContext<ProductStateModel>, action: SelectCategoryAction) {
    const state = ctx.getState();
    let selectList = [];

    state.categories.forEach(x => {
      if (x.model.subCategory === action.payload.category.model.subCategory) {
        let c = new CategoryModel(action.payload.category.model)
        c.isSelected = x.isSelected ? false : true;
        selectList.push(c);
      } else {
        selectList.push(new CategoryModel(x.model));
      }
    })

    ctx.patchState({
      categories: selectList//state.categories.map((category) => (category.name === action.payload.category.name ? new CategoryModel('').select(action.payload.category) : category))
    });
    ctx.dispatch(new UpdateBrandAction())

  }



  @Action(GetProductBySkuAction)
  getProductsBySkuCodeAction(ctx: StateContext<ProductStateModel>, action: GetProductBySkuAction) {
    ctx.patchState({
      isLoading: true
    });
    return this.productService.getProductBySkuCode(action.payload.loadProductsBySkuQuery).pipe(
      tap((result) => ctx.dispatch(new GetProductBySkuSuccessAction({ loadProductsBySkuQuery: result }))),
      catchError((err) => ctx.dispatch(new GetProductBySkuFailAction(err))),

    );

  }


  @Action(GetProductBySkuSuccessAction)
  getProductBySkuSuccessAction(ctx: StateContext<ProductStateModel>, action: GetProductBySkuSuccessAction) {
    ctx.patchState({
      isLoading: false,
      ProductBySkuCode: action.payload.loadProductsBySkuQuery,
    });

  }

  @Action(GetProductBySkuFailAction)
  getProductBySkuFailAction(ctx: StateContext<ProductStateModel>, action: GetProductBySkuFailAction) {
    ctx.patchState({
      isLoading: false,
      ProductBySkuCode: new SkuResult(),
    });

  }

  @Action(UploadProductImagesAction)
  uploadProductImagesAction(ctx: StateContext<ProductStateModel>, action: UploadProductImagesAction) {
      ctx.patchState({
          isLoading: true
      });

      return this.productService.uploadFiles(action.payload.command).pipe(
          tap((result) => ctx.dispatch(new UploadProductImagesSuccessAction({ status: result }))),
          catchError((err) => ctx.dispatch(new UploadProductImagesFailAction(err))),
      );
  }

  @Action(UploadProductImagesSuccessAction)
  uploadProductImagesSuccessAction(ctx: StateContext<ProductStateModel>, action: UploadProductImagesSuccessAction) {
      ctx.patchState({
          isLoading: false,
      });
      ctx.dispatch(new OpenToastrAction({ message: 'Files uploaded successfully', type: ToastrType.success, title: 'Success' }));
    //   ctx.dispatch(new Navigate(['/products'], { category: 'home' }));
  }

  @Action(UploadProductImagesFailAction)
  uploadProductImagesFailAction(ctx: StateContext<ProductStateModel>, action: UploadProductImagesFailAction) {
      ctx.patchState({
          isLoading: false,
      });
  }

  @Action(AssignCoverImageAction)
  assignCoverImageAction(ctx: StateContext<ProductStateModel>, action: AssignCoverImageAction) {
      ctx.patchState({
          isLoading: true
      });

      return this.productService.assignCover(action.payload.command).pipe(
          tap((result) => ctx.dispatch(new AssignCoverImageSuccessAction({ status: result }))),
          catchError((err) => ctx.dispatch(new AssignCoverImageFailAction(err))),
      );
  }

  @Action(AssignCoverImageSuccessAction)
  assignCoverImageSuccessAction(ctx: StateContext<ProductStateModel>, action: AssignCoverImageSuccessAction) {
      ctx.patchState({
          isLoading: false,
      });
      ctx.dispatch(new OpenToastrAction({ message: 'Cover Image set successfully', type: ToastrType.success, title: 'Success' }));
  }

  @Action(AssignCoverImageFailAction)
  assignCoverImageFailAction(ctx: StateContext<ProductStateModel>, action: AssignCoverImageFailAction) {
      ctx.patchState({
          isLoading: false,
      });
  }

  @Action(UpdateDescriptionAction)
  updateDescriptionAction(ctx: StateContext<ProductStateModel>, action: UpdateDescriptionAction) {
      ctx.patchState({
          isLoading: true
      });

      return this.productService.updateDescription(action.payload.command).pipe(
          tap((result) => ctx.dispatch(new UpdateDescriptionSuccessAction({ loadProductsBySkuQuery: result }))),
          catchError((err) => ctx.dispatch(new UpdateDescriptionFailAction(err))),
      );
  }

  @Action(UpdateDescriptionSuccessAction)
  updateDescriptionSuccessAction(ctx: StateContext<ProductStateModel>, action: UpdateDescriptionSuccessAction) {
      ctx.patchState({
          isLoading: false,
          ProductBySkuCode: action.payload.loadProductsBySkuQuery,
      });
      ctx.dispatch(new OpenToastrAction({ message: 'Product Description Updated Successfully', type: ToastrType.success, title: 'Success' }));
  }

  @Action(UpdateDescriptionFailAction)
  updateDescriptionFailAction(ctx: StateContext<ProductStateModel>, action: UpdateDescriptionFailAction) {
      ctx.patchState({
          isLoading: false,
      });
  }
}
